import api from './api';

const complianceRuleMasterService = {
  // Get all compliance rules
  getAllComplianceRules: async (params = {}) => {
    try {
      const queryParams = new URLSearchParams();
      if (params.page) queryParams.append('page', params.page);
      if (params.limit) queryParams.append('limit', params.limit);
      if (params.status) queryParams.append('status', params.status);
      if (params.category) queryParams.append('category', params.category);
      if (params.priority) queryParams.append('priority', params.priority);
      if (params.search) queryParams.append('search', params.search);

      const queryString = queryParams.toString();
      const url = `/compliance-rule-master${queryString ? `?${queryString}` : ''}`;
      
      const response = await api.get(url);
      return response.data;
    } catch (error) {
      console.error('Error fetching compliance rules:', error);
      throw error;
    }
  },

  // Get compliance rule by ID
  getComplianceRuleById: async (id) => {
    try {
      const response = await api.get(`/compliance-rule-master/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching compliance rule:', error);
      throw error;
    }
  },

  // Get next compliance rule code
  getNextComplianceRuleCode: async () => {
    try {
      const response = await api.get('/compliance-rule-master/code/next');
      return response.data;
    } catch (error) {
      console.error('Error fetching next compliance rule code:', error);
      throw error;
    }
  },

  // Create compliance rule
  createComplianceRule: async (complianceRuleData) => {
    try {
      const response = await api.post('/compliance-rule-master', complianceRuleData);
      return response.data;
    } catch (error) {
      console.error('Error creating compliance rule:', error);
      throw error;
    }
  },

  // Update compliance rule
  updateComplianceRule: async (id, complianceRuleData) => {
    try {
      const response = await api.put(`/compliance-rule-master/${id}`, complianceRuleData);
      return response.data;
    } catch (error) {
      console.error('Error updating compliance rule:', error);
      throw error;
    }
  },

  // Delete compliance rule
  deleteComplianceRule: async (id) => {
    try {
      const response = await api.delete(`/compliance-rule-master/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error deleting compliance rule:', error);
      throw error;
    }
  },

  // Get compliance rule statistics
  getComplianceRuleStats: async () => {
    try {
      const response = await api.get('/compliance-rule-master/stats');
      return response.data;
    } catch (error) {
      console.error('Error fetching compliance rule statistics:', error);
      throw error;
    }
  }
};

export default complianceRuleMasterService;

